import moment from "moment";

export default function getInfoObject(payload, portfolioElement) {
    return {
        header: {
            id: "",
            parent_id: "",
            portfolio_element: portfolioElement,
            client: "",
            node: "",
            version: "1-0-1",
            type: "SINGLE",
            status: "NEW",
            encryption_level: "0",
            encryption_key: "",
            process_history: [
                {
                    step: "1",
                    timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
                    unit: "",
                    type: "SERVICE_REQUEST",
                    status: "NEW",
                    status_comment: ""
                }
            ]
        },
        container: [
            {
                header: {
                    id: "",
                    parent_id: "",
                    portfolio_element: portfolioElement,
                    client: "",
                    node: "",
                    version: "1-0-1",
                    type: "SERVICE_REQUEST",
                    status: "NEW",
                    encryption_level: "0",
                    encryption_key: ""
                },
                payload: payload
            }
        ]
    };
}